/**
 * @member {string} id
 * @member {string} name
 * @member {string} comment
 * @member {string} ln_color
 * @member {string} bg_color
 */
export default class StatusDto {
  id
  bg_color
  comment
  ln_color
  name

  /**
   * @param {string} id
   * @param {string} name
   * @param {string} comment
   * @param {string} ln_color
   * @param {string} bg_color
   */
  constructor({ id, name, comment, ln_color, bg_color }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    id = String(id)
    bg_color = String(bg_color)
    comment = String(comment)
    ln_color = String(ln_color)
    name = String(name)

    Object.defineProperty(this, 'id', Object.assign({ value: id }, properties))
    Object.defineProperty(this, 'bg_color', Object.assign({ value: bg_color }, properties))
    Object.defineProperty(this, 'comment', Object.assign({ value: comment }, properties))
    Object.defineProperty(this, 'ln_color', Object.assign({ value: ln_color }, properties))
    Object.defineProperty(this, 'name', Object.assign({ value: name }, properties))

    Object.freeze(this)
  }
}
